import React from "react";
import ReactDOM from "react-dom";
import App from './App';
import dotenv from 'dotenv';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-tabs/style/react-tabs.scss';
import './assets/styles/app.scss';
import './assets/styles/menubar.scss';
import './assets/styles/filters.scss';
import './assets/styles/capacidad-indicators.scss';
import './assets/styles/galpon-layout.scss';
import './assets/styles/programadas-capacidad.scss';

// react-datepicker resuelve el prop locale={"es"} contra un registro global.
// Sin registerLocale ese string no coincide con nada y el calendario cae a
// ingles. Hay 9 instancias que pasan el string; esto las corrige de una vez.
registerLocale('es', es);
setDefaultLocale('es');

dotenv.config();

ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
